import * as React from 'react';
import AddCarForm from '../Layout/Form/AddCarForm';
import * as UserModule from 'Modules/UserModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import { connect } from 'react-redux';
import VehiclesListFull from './VehiclesListFull';

type Props = {
    history: any;
};

type ConnectedDispatch = {
    createNewCar: Function;
};

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
};

type State = {
    // vehicleListVisible: boolean;
};

class CarsManagement extends React.PureComponent<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async handleSubmit(formData) {
        const newCarData: VehiclesModule.Types.AddCarRequest = formData;
        newCarData.userId = this.props.userStore.user.id;
        const { createNewCar } = this.props;
        await createNewCar(newCarData);
    }
    public render() {
        return (
            <div className="main__content main__content--no-padding">
                <VehiclesListFull />
            </div>
        );
    }
}
function mapStateToProps(state: any): ConnectedProps {
    return {
        userStore: state.userStore,
        vehiclesStore: state.vehiclesStore
    };
}
function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        createNewCar: (newVehicleData: VehiclesModule.Types.AddCarRequest) => dispatch(VehiclesModule.Actions.addCar(newVehicleData))
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CarsManagement) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/CarsManagement/CarsManagement.tsx